import React, { useState, useEffect, useRef } from "react";
import Response_Processing from "../../../../src/layout/Others/Response_Processing";
import { useNavigate, useParams } from "react-router-dom";
import AdminBackNavigation from "../../../components/CommonComponents/AdminBackNavigation";
import AdminSaveHeader from "../../../components/CommonComponents/AdminSaveHeader";
import FormContainer from "../../../components/CommonComponents/FormContainer";
import LeftWrapper from "../../../components/CommonComponents/LeftWrapper";
import Wrapper from "../../../components/CommonComponents/Wrapper";
import MessageLabel from "../../../components/CommonComponents/MessageLabel";
import AdminCustomInput from "../../../components/CommonComponents/AdminCustomInput";
import AdminCustomSelect from "../../../components/CommonComponents/AdminCustomSelect";
import RightWrapper from "../../../components/CommonComponents/RightWrapper";
import MessageHeading from "../../../components/CommonComponents/MessageHeading";
import { toast } from "react-toastify";
import axios from "axios";
import { connect } from "react-redux";

function Editorderhome({ onlyPermission, ...props }) {
  const { id } = useParams();
  const navigate = useNavigate();
  const [editUser, setEditUser] = useState({
    id: "",
    header_name: "",
    order_id: "",
    url: "",
    user_id: "",
    web_orientation_view: "",
    mobile_orientation_view: "",
    tv_orientation_view: "",
    samsung_orientation_view: "",
    lg_orientation_view: "",
    analytics_trend_window: "",
  });

  const [orientations, setOrientations] = useState([]);
  const [message, setMessage] = useState("");
  const access_token = localStorage.getItem("access_token");

  const headers = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + access_token,
    Accept: "application/json",
    "Access-Control-Allow-Origin": "*",
  };

  const fetchOrientations = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_Baseurl}/admin/orientation/index`, { headers });
      if (response.data?.status && response.data?.data) {
        setOrientations(response.data.data);
      }
    } catch (error) {
      console.error('Error fetching orientations:', error);
    }
  };

  useEffect(async () => {
    const getUser = async () => {
      const reqData = await fetch(
        `${process.env.REACT_APP_Baseurl}/admin/HomePage-Order/edit/${id}`,
        { headers: headers }
      );
      const resData = await reqData?.json();
      var res = resData?.Web_HomePage_Order;

      // Permission check for shorts
      if (res?.name === 'vertical_shorts' && !onlyPermission?.includes(45)) {
        toast.error("You don't have permission to edit Vertical Shorts.");
        navigate('/home-settings');
        return;
      }
      if (res?.name === 'horizontal_shorts' && !onlyPermission?.includes(46)) {
        toast.error("You don't have permission to edit Horizontal Shorts.");
        navigate('/home-settings');
        return;
      }

      setEditUser(res);
    };
    getUser();
    fetchOrientations();
  }, [id]);


  const handleOrientationChange = (e) => {
    const { name, value } = e.target;
    setEditUser({
      ...editUser,
      [name]: value || null
    });
  };


  const handleInput = (e) => {
    setEditUser({ ...editUser, [e.target.name]: e.target.value });
  };

  const [validationMessageheader_name, setValidationMessageheader_name] =
    useState("");
  const [isValidationHiddenheader_name, setIsValidationHiddenheader_name] =
    useState(true);

  const [validationMessageurl, setValidationMessageurl] =
    useState("");
  const [isValidationHiddenurl, setIsValidationHiddenurl] =
    useState(true);

  const header_nameInputRef = useRef(null);
  const url_nameInputRef = useRef(null);

  const [processing, setProcessing] = useState(false);
  const [showOverlay, setShowOverlay] = useState(false);

  const handleUpdate = async (e) => {
    let focusInputRef = null;

    if (editUser?.header_name === "") {
      setValidationMessageheader_name("Header Name cannot be empty.");
      setIsValidationHiddenheader_name(false);
      focusInputRef = header_nameInputRef;
    }

    if (!editUser?.url || editUser.url.trim() === "") {
      setValidationMessageurl("Slug cannot be empty.");
      setIsValidationHiddenurl(false);
      focusInputRef = url_nameInputRef;
    }

    if (focusInputRef) {
      focusInputRef.current.focus();
      return;
    }

    e.preventDefault();

    const editInputvalue = {
      id: editUser?.id,
      user_id: editUser?.user_id,
      order_id: editUser?.order_id,
      url: editUser?.url,
      header_name: editUser?.header_name,
      name: editUser?.header_name,
      web_orientation_view: editUser?.web_orientation_view,
      mobile_orientation_view: editUser?.mobile_orientation_view,
      tv_orientation_view: editUser?.tv_orientation_view,
      samsung_orientation_view: editUser?.samsung_orientation_view,
      lg_orientation_view: editUser?.lg_orientation_view,
      analytics_trend_window: editUser?.analytics_trend_window,
    };

    let firstApiStatus = false;
    let resultapi = null;
    let resjson = null;
    setProcessing(true);
    setShowOverlay(true);

    try {
      const res = await fetch(
        `${process.env.REACT_APP_Baseurl}/admin/HomePage-Order/update`,
        {
          method: "PATCH",
          headers: headers,
          body: JSON.stringify(editInputvalue),
        }
      );

      resjson = await res.json();

      if (resjson.status === true) {
        firstApiStatus = true;

        resultapi = resjson;
      }
    } catch (error) {
      console.error("Error:", error);
    }

    if (firstApiStatus) {
      // setValidationMessageheader_name("");
      // setValidationMessageurl("");
      // props.setApiresponsealert(resultapi);
      // props.setShowalert(true);
      // window.location.reload();
      setProcessing(false);
      setShowOverlay(false);
      toast.success(resultapi.message)
    } else {
      if (resjson.status === false) {
        var resultError = resjson;
        toast.error(resultError.errors[0].msg)
        props.setApiresponsealert(resultError);
        props.setShowalert(true);
        setIsValidationHiddenheader_name(false);
        setIsValidationHiddenurl(false);
        setProcessing(false);
        setShowOverlay(false);
      }
    }
  };

  return (
    <>
      {showOverlay && (<Response_Processing />)}
      {<AdminBackNavigation path={`${'/home-settings'}`} text="Back" />}
      <AdminSaveHeader heading="Edit Order Home" saveText="Update Order" saveMethod={handleUpdate} />
      <FormContainer>
        <LeftWrapper>
          <Wrapper>
            <MessageLabel text={"Home Page Header"} className="mandatorySimple" />
            <AdminCustomInput type="text" id="header_name" name="header_name" value={editUser?.header_name} onChange={handleInput} placeHolder={"Enter header name"} ref={header_nameInputRef} error={validationMessageheader_name} />
            <MessageLabel text={"Slug"} className="mandatorySimple" />
            <AdminCustomInput type="text" id="url" name="url" value={editUser?.url} onChange={handleInput} placeHolder={"Enter url"} ref={url_nameInputRef} error={validationMessageurl} />

            {editUser?.name === "analytics_trending_now" && (
              <>
                <MessageLabel text={"Trending Window"} />
                <AdminCustomSelect
                  name="analytics_trend_window"
                  value={editUser?.analytics_trend_window || "7d"}
                  onChange={handleOrientationChange}
                  options={[
                    { value: "24h", name: "Last 24 Hours" },
                    { value: "7d", name: "Last 7 Days" },
                    { value: "30d", name: "Last 30 Days" },
                    { value: "all", name: "Overall" },
                  ]}
                  defaultOptionName="Select Trending Window"
                />
              </>
            )}
          </Wrapper>
        </LeftWrapper>
        <RightWrapper>
          <Wrapper>
            <MessageHeading text={"Orientation Settings"} />
            <MessageLabel text={"Web View Slider"} />
            <AdminCustomSelect
              name="web_orientation_view"
              value={editUser?.web_orientation_view || ""}
              onChange={handleOrientationChange}
              options={orientations.map(orientation => ({
                value: orientation.id,
                name: `${orientation.name} (${orientation.images_size || 'N/A'})`
              }))}
              defaultOptionName="Select Orientation"
            />
            <MessageLabel text={"Mobile View Slider"} />
            <AdminCustomSelect
              name="mobile_orientation_view"
              value={editUser?.mobile_orientation_view || ""}
              onChange={handleOrientationChange}
              options={orientations.map(orientation => ({
                value: orientation.id,
                name: `${orientation.name} (${orientation.images_size || 'N/A'})`
              }))}
              defaultOptionName="Select Orientation"
            />

            <MessageLabel text={"TV View Slider"} />
            <AdminCustomSelect
              name="tv_orientation_view"
              value={editUser?.tv_orientation_view || ""}
              onChange={handleOrientationChange}
              options={orientations.map(orientation => ({
                value: orientation.id,
                name: `${orientation.name} (${orientation.images_size || 'N/A'})`
              }))}
              defaultOptionName="Select Orientation"
            />

            <MessageLabel text={"Samsung View Slider"} />
            <AdminCustomSelect
              name="samsung_orientation_view"
              value={editUser?.samsung_orientation_view || ""}
              onChange={handleOrientationChange}
              options={orientations.map(orientation => ({
                value: orientation.id,
                name: `${orientation.name} (${orientation.images_size || 'N/A'})`
              }))}
              defaultOptionName="Select Orientation"
            />

            <MessageLabel text={"LG View Slider"} />
            <AdminCustomSelect
              name="lg_orientation_view"
              value={editUser?.lg_orientation_view || ""}
              onChange={handleOrientationChange}
              options={orientations.map(orientation => ({
                value: orientation.id,
                name: `${orientation.name} (${orientation.images_size || 'N/A'})`
              }))}
              defaultOptionName="Select Orientation"
            />


          </Wrapper>
        </RightWrapper>
      </FormContainer>
    </>
  );
}

const mapStateToProps = (state) => ({
  onlyPermission: state.userPermission.onlyPermission
});

export default connect(mapStateToProps)(Editorderhome);
